import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  MenuItem,
  Grid,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import axios from 'axios';
import { logActivitySafe } from '../../utils/logActivitySafe';

const ExaminationCreate: React.FC = () => {
  const [name, setName] = useState('');
  const [examTypeId, setExamTypeId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [examTypes, setExamTypes] = useState<any[]>([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchExamTypes();
  }, []);

  const fetchExamTypes = async () => {
    try {
      const response = await axios.get('/system-settings/masters/exam-type');
      setExamTypes(response.data);
    } catch (error) {
      console.error('Failed to fetch exam types:', error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Track attempt
    logActivitySafe({
        module: 'EXAMINATION',
        action: 'CLICK_BUTTON',
        description: `Attempting to create exam: ${name}`
    });

    try {
      await axios.post('/exams', {
        name,
        examTypeId,
        startDate,
        endDate,
      });

      // Track success
      logActivitySafe({
        module: 'EXAMINATION',
        action: 'SUBMIT_FORM',
        description: `Created exam: ${name}`
      });

      navigate('/examinations');
    } catch (error: any) {
      setError(error.response?.data?.message || 'Failed to create examination');
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="md">
        <Paper sx={{ p: 4, mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            Create Examination
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  label="Examination Name"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Exam Type"
                  fullWidth
                  value={examTypeId}
                  onChange={(e) => setExamTypeId(e.target.value)}
                  required
                >
                  {examTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* Spacer or additional field */}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Start Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="End Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  required
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
              <Button variant="contained" type="submit">
                Create Examination
              </Button>
              <Button variant="outlined" onClick={() => navigate('/examinations')}>
                Cancel
              </Button>
            </Box>
          </form>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default ExaminationCreate;
